import ConnectionService from "../../../services/connection/ConnectionService";

export default {
  created() {
    this._objectUrls = {};
  },
  methods: {
    async loadCoverImage(originalUrl) {
      if (!originalUrl) return null;
      const token = originalUrl.split("/").pop();
      try {
        const blob = await ConnectionService.getFile(token);
        const objectUrl = URL.createObjectURL(blob);
        this._objectUrls[originalUrl] = objectUrl;
        return objectUrl;
      } catch (e) {
        console.warn("Não foi possível carregar a imagem de capa:", e);
        return null;
      }
    },
    _revokeCoverImages() {
      if (!this._objectUrls) return;
      Object.values(this._objectUrls).forEach(URL.revokeObjectURL.bind(URL));
      this._objectUrls = {};
    },
  },
  beforeDestroy() {
    this._revokeCoverImages();
  },
};
